import { Suspense } from 'react';

import { FCC, Skeleton, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

const SkeletonLine: React.FC = () => {
  return <Skeleton className="h-6 w-full bg-white" />;
};

export const AppointmentPageLoader: FCC = ({ children }) => {
  const { t } = useTranslation();
  return (
    <Suspense
      fallback={
        <Stack className="container mt-24" gap={2} align="stretch">
          <Text>{t('appointmentTools.page.loadingAppointment')}</Text>
          <SkeletonLine />
          <SkeletonLine />
          <SkeletonLine />
        </Stack>
      }
    >
      {children}
    </Suspense>
  );
};
